export const CLOSE_DELAY_MS = 180;
export const ZEN_PORTAL_ANCHOR = { top: 16, right: 16 };
export const DEFAULT_OPEN_DELAY_MS = 500;
